const configFunc = {

    HttpEndpoint: (path) => `${window.SCHEMA}://${window.ENDPOINT}${path}`,
    SocketEndpoint: (path) => `${window.WEBSOCKET_SCHEMA}://${window.ENDPOINT}${path}`
}

export default configFunc